import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Badge(): Components<Theme> {
  return {
    MuiBadge: {
      styleOverrides: {
        dot: {
          width: 10,
          height: 10,
          borderRadius: "50%",
        },
      },
    },
  };
}
